import * as React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./sites/App";
import reportWebVitals from "./reportWebVitals";

import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import mixpanel from "mixpanel-browser";

const firebaseConfig = {
  apiKey: "AIzaSyAp4bpVQxfyeroxdI3437eOAX65vX_gcGc",
  authDomain: "valentinahrend-ac6bb.firebaseapp.com",
  projectId: "valentinahrend-ac6bb",
  storageBucket: "valentinahrend-ac6bb.appspot.com",
  messagingSenderId: "132053204383",
  appId: "1:132053204383:web:aed16a38e53f606d4dd1aa",
  measurementId: "G-4RN4XZCNC2"
};

// Create an instance of the Mixpanel object, your token is already added to this snippet
mixpanel.init('74756c03aea0b9ad9258500d827e7ccd', {
  autocapture: true,
  record_sessions_percent: 100,
  api_host: 'https://api-eu.mixpanel.com',
})
// Initialize Firebase
const app = initializeApp(firebaseConfig);
getAnalytics(app);

ReactDOM.render(
  <React.Fragment>
    <App />
  </React.Fragment>,
  document.getElementById("root")   // 👈 REQUIRED
);

reportWebVitals();